import {useEffect, useState} from "react";
import useFetch from "use-http";

const useStoresData = () => {
    const [stores, setStores] = useState([])
    const {get, response, loading, error} = useFetch(`${process.env.REACT_APP_API_PATH}`,{
        loading:true
    })

    useEffect(() => {
        (async function (){
            const fetchedData = await get('/wp/v2/stores?orderby=title&order=asc&per_page=100');
            if(response.ok) {
                setStores(fetchedData);
            }
        })().catch()
    }, [response.ok,get])

    return {data : stores, loading : loading, error : error};
}

export default useStoresData;